import { RouterProvider } from 'react-router-dom'
import Router from './router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
// import { QueryParamProvider } from 'use-query-params'
// import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'
// import RootLayout from './layouts/root-layout'

const queryClient = new QueryClient()

function App() {
  // useScrollRestoration()
  return (
    <div className="app">
      <QueryClientProvider client={queryClient}>
        {/* <QueryParamProvider adapter={ReactRouter6Adapter}> */}
        <RouterProvider router={Router} />
        {/* </QueryParamProvider> */}
        {/* <Router /> */}
      </QueryClientProvider>
    </div>
  )
}

export default App
